import React from "react";

import ModalFieldBoolean from "components/ModalFieldBoolean";
import { FieldOption } from "components/FieldSelect/FieldSelect";
import { EditableTableColumn } from "components/EditableTable/EditableTable";
import { withSelectedOption } from "services/withSelectedOption";

type Params<T> = {
	initialValue: (arg: T) => boolean;
};

export function columnDefinitionIsEnabled<T>({
	initialValue
}: Params<T>): EditableTableColumn<T> {
	const field: EditableTableColumn<T>["field"] = ({
		row,
		rowKey,
		isEditing,
		onEdit
	}) => {
		return (
			<ModalFieldBoolean
				isUnlocked={isEditing}
				title="Enabled"
				initialValue={initialValue(row)}
				onOK={(newOptions: FieldOption[]) => {
					withSelectedOption(newOptions, value => {
						const newData = {
							...row,
							[rowKey]: !!value
						};
						onEdit([{ old: row, new: newData }]);
					});
				}}
			/>
		);
	};

	const output = {
		key: "isEnabled",
		heading: "Enabled",
		field
	};

	return output;
}
